import type { SiteBriefTaskType } from '../api.types';

type BriefVersion = {
  id: string;
  version: number;
  task?: SiteBriefTaskType | null;
};

// Tasks advance independently of the brief version, including retries of the same task.
export function isOlderBrief(incoming: BriefVersion, current: BriefVersion | null | undefined): boolean {
  if (!current || incoming.id !== current.id) {
    return false;
  }
  if (incoming.version < current.version) {
    return true;
  }
  const previous = current.task;
  const next = incoming.task;
  if (!previous || next === undefined) {
    return false;
  }
  if (!next) {
    return incoming.version <= current.version;
  }
  if (next.id !== previous.id) {
    return next.created_at < previous.created_at;
  }
  if (next.attempts !== previous.attempts) {
    return next.attempts < previous.attempts;
  }
  if (next.updated_at !== previous.updated_at) {
    return next.updated_at < previous.updated_at;
  }
  const rank = { queued: 0, running: 1, cancelling: 2, cancelled: 3, completed: 3, failed: 3 };
  return rank[next.state] < rank[previous.state];
}
